// ─── Scenario display order ──────────────────────────────────────────
// Retool parity: the Scenario filter lists options in this product-defined order,
// not alphabetically. Values match the `feature` column of features_mapping
// (type='Scenario'). Scenarios missing from this list still show, after the
// known ones, alphabetically — a new features_mapping scenario never disappears.
export const SCENARIO_DISPLAY_ORDER = [
  'Concept',
  'Narrative',
  'Text Overlay',
  'Voice Over',
  'Brand Metadata',
  'Asset Metadata',
  'Presenter',
  'Product',
  'Audio',
  'Background',
  'Text Style',
  'Sequence',
  'Social Post Headline',
  'Social Post Body',
] as const;

const SCENARIO_RANK = new Map<string, number>(SCENARIO_DISPLAY_ORDER.map((name, index) => [name, index]));

export function sortScenariosByDisplayOrder(scenarios: readonly string[]): string[] {
  return [...scenarios].sort((a, b) => {
    const rankA = SCENARIO_RANK.get(a) ?? SCENARIO_DISPLAY_ORDER.length;
    const rankB = SCENARIO_RANK.get(b) ?? SCENARIO_DISPLAY_ORDER.length;
    return rankA - rankB || a.localeCompare(b);
  });
}
